import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const loginGuard: CanActivateFn = () => {
  const router = inject(Router);
  const state = router.getCurrentNavigation()?.extras.state;

  return state ? true : router.createUrlTree(['login']);
};
